
import color from "../../constants/color";

const styles = {
  containerInput:{
    display: {sx: "block", md:"flex"},
    alignItems: "center",
  },
  label:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text
  },
  inputBox: {
    width: {xs:"100%", md: "49%"},
    mr:1
  },
  addButtons: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: color.primary, 
    fontSize: "12px",
    fontWeight: "500",
    px: 4,
    boxShadow: "none",
    marginRight:"5px"
  },


  hoursInput: {
    width: "100%",
    borderRadius: "8px",
    height: "2.5em",
    mt:1,

    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
      borderRadius: "8px",

    },
    "& .css-156w56f-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: "8px",

    },
  },

  modalInput:{
    display:"flex",    // backgroundColor:color.lightGray,
    borderRadius:"30px",
    // width:{ xs: "25em", md: "35em" },
    justifyContent:"center" ,// Center align on smaller screens
    my:"10px",
    height:"2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"8.5px 14px"
    },
    "& .MuiOutlinedInput-root":{
      padding:"0"
    }
  },
  inputSpace: {
    "& .MuiOutlinedInput-root":{
      padding:"0px 14px"
    }

  },
  dropDownMenu:{
    fontSize:"12px",
    my:"10px",

    fontWeight:"500",
    width: "100%",
    height: "40px"
  },
  dropDown:{
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"8px 14px",
    },
  },
  formControlLabel: {
    display: "block",
    fontSize: "14px",
    color: color.text,
  },
  mainGrid:{
    display:"flex",
    gap: "8px",
    justifyContent:"space-between",
    p: 2,
    backgroundColor:color.card

  },
  bckBtn:{
    borderRadius: "50%",
    minWidth:"0px",
    width: "38px"
  },
  companyInfo: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    maxWidth: { xs: "140px", sm: "220px" },
  },
  companyLogo: {
    width: "32px",
    height: "32px",
  },
  companyName: {
    fontSize: "14px",
    fontWeight: "600",
    color: color.text,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}
export default styles;